module.exports = __webpack_public_path__ + "img/cross.58b5b125.svg";